// 系统字段
import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import { useEffect, useCallback, createContext, useState } from 'react';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import InOutPut from './components/in_out_put/InOutPut';
import { isEmptyObject } from '@/utils/comUtil.js';
import ModalML from '@/components/modal_ml/ModalML';
import dayjs from 'dayjs';

export const FunctionContext = createContext({
  fetchData: () => {},
});
const Dr = () => {
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['der/getExecutionRecord'];
  const bizData = useSelector((state) => state.der.executionRecordList);
  const [modalVisible, setModalVisible] = useState(false);
  const [logTableData, setLogTableData] = useState([]);
  const [inOutPut, setInOutPut] = useState([]);
  const [params, setParams] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const pageSizeChange = (val) => {
    setPageSize(val);
    setPage(1);
  };

  const pageNumChange = ({ current }) => {
    setPage(current);
  };

  const setParamsFun = (param) => {
    if (param.createTimeBegin) {
      param.createTimeBegin = dayjs(param.createTimeBegin.$d).format(
        'YYYY-MM-DD HH:mm:ss',
      );
    }
    if (param.createTimeEnd) {
      param.createTimeEnd = dayjs(param.createTimeEnd.$d).format(
        'YYYY-MM-DD HH:mm:ss',
      );
    }
    setPage(1);
    setParams(param);
  };

  // 条件查询列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'der/getExecutionRecord',
      payload: {
        values: {
          page: page,
          limit: pageSize,
          ...params,
        },
      },
    });
  }, [dispatch, page, pageSize, params]);

  // 发起请求
  useEffect(() => {
    fetchData({});
  }, [fetchData]);

  const showModal = (e, type) => {
    setModalVisible(true);
    setInOutPut(type);
    setLogTableData(e);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  return (
    <FunctionContext.Provider value={{ fetchData }}>
      <div className={styles.mm_content}>
        <SearchGroup setParamsFun={setParamsFun} />
        {/* <ApprovalList /> */}
        {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
        <TablePage
          pagination={{
            total: !isEmptyObject(bizData) ? bizData.total : 0,
            pageSize: pageSize,
            page: page,
          }}
          loading={loading}
          tableData={bizData.data || []}
          loadingstatus={loading}
          showModal={showModal}
          pageSizeChange={pageSizeChange}
          pageNumChange={pageNumChange}
        />
        <ModalML
          title={inOutPut === 'in' ? '输入值' : '输出项'}
          width="40vw"
          visible={modalVisible}
          handleCancel={handleCancel}
        >
          <InOutPut tableData={logTableData} inOutPut={inOutPut} />
        </ModalML>
      </div>
    </FunctionContext.Provider>
  );
};

export default Dr;
